import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import setup from "./services/setup";
import AuthService from "./services/auth";

import "@/assets/styles/main.scss";
import "@/assets/styles/fonts.scss";
import "@/assets/styles/media.scss";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "bootstrap/dist/js/bootstrap";
import "bootstrap/dist/css/bootstrap.css";

import { fetchPageMeta } from "@/services/pageMeta";
import { applyHead } from "@/utils/head";

import { injectMetrika, hit } from "./metrics/yandexMetrika";

setup();
// Попытка автологина при запуске приложения
AuthService.autoLogin().catch((error) => {
  console.log("Auto login failed", error);
});

const isProd = process.env.NODE_ENV === "production";

if (isProd) {
  injectMetrika();
  router.afterEach((to) => {
    hit(to.fullPath || window.location.pathname + window.location.search);
  });
}

// Глобальный хук для метатегов
const metaCache = new Map<string, any>();

const hasUsefulMeta = (m: any) =>
  m &&
  (m.title ||
    m.description ||
    m.additional_title ||
    m.text_field ||
    (Array.isArray(m.keywords) && m.keywords.length) ||
    Object.keys(m).length > 0); // если хочешь принимать любой непустой объект

// main.ts
router.afterEach(async (to) => {
  // 1) формируем slug:
  //    - "/"   -> "/"
  //    - "/a"  -> "a"
  //    - "/a/" -> "a"
  const rawPath = to.path || "/";
  const slug =
    rawPath === "/" ? "/" : rawPath.replace(/^\/+/, "").replace(/\/+$/, "");

  const candidates = [slug]; // одного достаточно, но оставил массив на будущее

  for (const s of candidates) {
    if (metaCache.has(s)) {
      applyHead(metaCache.get(s) || undefined);
      store.commit("pageMeta/set", metaCache.get(s) || undefined);
      return;
    }
    try {
      const meta = await fetchPageMeta(s);
      if (meta && hasUsefulMeta(meta)) {
        metaCache.set(s, meta);
        applyHead(meta);
        store.commit("pageMeta/set", meta);
        return;
      } else {
        metaCache.set(s, null);
        store.commit("pageMeta/clear");
      }
    } catch {
      metaCache.set(s, null);
      store.commit("pageMeta/clear");
    }
  }

  // дефолтные мета-теги
  applyHead();
  store.commit("pageMeta/clear");
});

createApp(App).use(store).use(router).mount("#app");
